import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from "@angular/core";
import { UiInteraction } from "@obg/ngx.core";
import { MenuItem } from "@obg/ngx.core.content";

@Component({
	selector: "obg-mobile-menu-item-list",
	templateUrl: "./mobile-menu-item-list.component.html",
	styleUrls: ["./mobile-menu-item-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class MobileMenuItemListComponent {
	@HostBinding("class.obg-mobile-menu-item-list") hostCssClass = true;
	@Input() uiInteraction: UiInteraction | undefined;
	@Input() titleText?: string | undefined;
	@Input() items: MenuItem[] = [];

	trackByItem(_index: number, item: MenuItem): string {
		return item.key;
	}
}
